<template>
  <div class="test-container" :class="{ 'theme--dark': $vuetify.theme.dark }">
    <div class="demo-header">
      <h2>MessageItemTimeline - Test View</h2>
      <v-btn @click="toggleTheme" class="theme-toggle" small>
        <v-icon left>{{ $vuetify.theme.dark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
        {{ $vuetify.theme.dark ? 'Light Mode' : 'Dark Mode' }}
      </v-btn>
    </div>

    <div class="test-section">
      <h3>1. Wiadomość od innego użytkownika</h3>
      <message-item-timeline :item="otherUserMessage" />
    </div>

    <div class="test-section">
      <h3>2. Wiadomość od bieżącego użytkownika</h3>
      <message-item-timeline :item="currentUserMessage" />
    </div>

    <div class="test-section">
      <h3>3. Ważna wiadomość</h3>
      <message-item-timeline :item="importantMessage" />
    </div>

    <div class="test-section">
      <h3>4. Wiadomość z błędem</h3>
      <message-item-timeline :item="errorMessage" />
    </div>

    <div class="test-section">
      <h3>5. Długa wiadomość z załącznikami</h3>
      <message-item-timeline :item="longMessageWithAttachments" />
    </div>

    <div class="test-section">
      <h3>6. Bez avatara</h3>
      <message-item-timeline :item="messageWithoutAvatar" :show-avatar="false" />
    </div>

    <div class="test-section">
      <h3>7. Duży avatar</h3>
      <message-item-timeline :item="otherUserMessage" :avatar-size="64" />
    </div>
  </div>
</template>

<script>
import MessageItemTimeline from '@/components/timeline/MessageItemTimeline.vue'

export default {
  name: 'MessageItemTimelineDemo',

  components: {
    MessageItemTimeline
  },

  data() {
    return {
      // Wiadomość od innego użytkownika
      otherUserMessage: {
        id: 1,
        title: 'Spotkanie projektowe',
        subtitle: 'Omówienie postępów',
        message: 'Jutro o 10:00 spotkanie w sali konferencyjnej. Prosimy o przygotowanie raportów.',
        details: 'Dodatkowe informacje o spotkaniu',
        isCurrentUser: false,
        important: false,
        user: {
          id: 2,
          name: 'Jan Kowalski',
          avatar_url: 'https://www.gravatar.com/avatar/4483fba3d03f7b0a6998e9c953e8a93f'
        },
        date: new Date('2025-01-15T10:30:00'),
        status: 'sent'
      },

      // Wiadomość od bieżącego użytkownika
      currentUserMessage: {
        id: 2,
        title: 'Odpowiedź',
        subtitle: 'Potwierdzenie',
        message: 'OK, będę na spotkaniu. Raporty już przygotowane.',
        isCurrentUser: true,
        important: false,
        user: {
          id: 1,
          name: 'Ty',
          avatar_url: 'https://www.gravatar.com/avatar/272?d=robohash'
        },
        date: new Date('2025-01-15T10:35:00'),
        status: 'sent'
      },

      // Ważna wiadomość
      importantMessage: {
        id: 3,
        title: 'PILNE',
        subtitle: 'Zmiana harmonogramu',
        message: 'Spotkanie przełożone na 14:00 z powodu awarii systemu.',
        details: 'Wszyscy uczestnicy zostali powiadomieni',
        isCurrentUser: false,
        important: true,
        user: {
          id: 3,
          name: 'Anna Nowak',
          avatar_url: 'https://www.gravatar.com/avatar/5?d=robohash'
        },
        date: new Date('2025-01-15T11:00:00'),
        status: 'sent'
      },

      // Wiadomość z błędem
      errorMessage: {
        id: 4,
        title: 'Błąd wysyłania',
        subtitle: 'Nie udało się wysłać',
        message: 'Ta wiadomość nie została dostarczona.',
        isCurrentUser: true,
        important: false,
        user: {
          id: 1,
          name: 'Ty'
        },
        date: new Date('2025-01-15T11:15:00'),
        status: 'error'
      },

      // Długa wiadomość z załącznikami
      longMessageWithAttachments: {
        id: 5,
        title: 'Szczegółowy raport',
        subtitle: 'Analiza miesięczna',
        message: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.`,
        details: 'Raport zawiera wszystkie dane z ostatniego miesiąca',
        isCurrentUser: false,
        important: false,
        user: {
          id: 4,
          name: 'Piotr Wiśniewski',
          avatar_url: 'https://www.gravatar.com/avatar/8?d=robohash'
        },
        attachments: [
          {
            id: 1,
            name: 'raport_styczen.pdf',
            url: '#'
          },
          {
            id: 2,
            name: 'dane_statystyczne.xlsx',
            url: '#'
          },
          {
            id: 3,
            name: 'prezentacja.pptx',
            url: '#'
          }
        ],
        date: new Date('2025-01-15T12:00:00'),
        status: 'sent'
      },

      // Wiadomość bez avatara
      messageWithoutAvatar: {
        id: 6,
        title: 'Notyfikacja systemowa',
        subtitle: 'Automatyczna wiadomość',
        message: 'System został zaktualizowany do najnowszej wersji.',
        isCurrentUser: false,
        important: false,
        user: null,
        date: new Date('2025-01-15T13:00:00'),
        status: 'sent'
      }
    }
  },

  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  }
}
</script>

<style scoped>
.test-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  min-height: 100vh;
  background-color: var(--v-background-base);
  transition: background-color 0.3s ease;
}

.demo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.theme-toggle {
  margin-left: 20px;
}

.test-section {
  margin-bottom: 30px;
  border: 1px solid;
  border-color: var(--v-primary-lighten4);
  border-radius: 8px;
  padding: 15px;
  background: var(--v-surface-base);
  transition: all 0.3s ease;
}

.test-section h3 {
  margin: 0 0 15px 0;
  color: var(--v-text-base);
  font-size: 16px;
}

h2 {
  color: var(--v-primary-base);
  margin: 0;
}

/* Dark theme adjustments */
.theme--dark .test-container {
  background-color: var(--v-background-base);
}

.theme--dark .test-section {
  background: var(--v-surface-base);
  border-color: var(--v-primary-darken2);
}

.theme--dark .test-section h3 {
  color: var(--v-text-base);
}
</style>
